module.exports = __webpack_public_path__ + "static/specialized-d2be6ddb5ac1162b18e49075e6b04004.svg";